import { axios } from '@/utils/request_trading'

const getStockstyle = (params) => {
    return axios({
        url: '/stock/style',
        method: 'post',
        data: params
      })
}
// /trade/create_style 创建风格账户
const getTradeCreatestyle = (params) => {
    return axios({
        url: '/trade/create_style',
        method: 'post',
        data: params
      })
}
// /trade/accounts
const getTradeAccounts = (params) => {
    return axios({
        url: '/app-api/stock/strategy-api/strategyPool/accountInfo',
        method: 'post',
        data: params
      })
}
// 删除策略账号web
const getTradeDel = (params) => {
    return axios({
        url: '/trade/delete',
        method: 'post',
        data: params
      })
}
// /trade/find_tactics 策略详情web
const getTradeFindTactics = (params) => {
    return axios({
        url: '/trade/find_tactics',
        method: 'post',
        data: params
      })
}
// /trade/update_tactics 修改策略web
const getTradeUpdateTactics = (params) => {
    return axios({
        url: '/trade/update_tactics',
        method: 'post',
        data: params
      })
}
export default {
    
    getStockstyle,
    getTradeCreatestyle,
    getTradeAccounts,
    getTradeDel,
    getTradeFindTactics,
    getTradeUpdateTactics
   
}